import VideoTutorialsModal from './VideoTutorialsModal';

export default VideoTutorialsModal;
